import nutritionImage from "../assets/images/healthy-menu-recipe-food-diet.jpg";
import ContentText from "./atoms/ContentText";
import HeadingText from "./atoms/HeadingText";
import { useTranslation } from "react-i18next";

const OurApproach = () => {
  const { t } = useTranslation();
  const contentText = [
    t("homepage.ourapproach.content.paragraph1"),
    t("homepage.ourapproach.content.paragraph2"),
    t("homepage.ourapproach.content.paragraph3"),
    t("homepage.ourapproach.content.paragraph4"),
  ].join("\n\n");

  return (
    <section className=" bg-white py-12 lg:mb-12">
      <div className="max-w-6xl mx-auto px-4 flex flex-col lg:flex-row mb-16">
        <div className="lg:w-[40%] relative">
          <div className="bg-primary-100 lg:absolute lg:left-[0%] lg:top-[10%] lg:w-[180%] p-6 lg:z-10 shadow-lg">
            <a href="#our-process">
              <HeadingText variant="h2">
                {t("homepage.ourapproach.heading")}
              </HeadingText>
              <ContentText classes="!text-base">{contentText}</ContentText>
            </a>
          </div>
        </div>
        <div className="lg:w-[60%] h-full w-full relative">
          <img
            src={nutritionImage}
            alt="Nutrition"
            className="h-auto w-auto max-w-full max-h-full"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-primary/20"></div>
        </div>
      </div>
    </section>
  );
};

export default OurApproach;
